// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CTar3","title":"Header_title__3QXvZ","side":"Header_side__3KzBx"};